import { render, staticRenderFns } from "./MoldingSelection.vue?vue&type=template&id=b1f531cc&scoped=true&"
import script from "./MoldingSelection.vue?vue&type=script&lang=js&"
export * from "./MoldingSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f531cc",
  null
  
)

export default component.exports